import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

// Actions
import { SetAuthData, Logout } from './auth.actions';

// Services
import { MsalService } from '@azure/msal-angular';

export interface AuthenticationStateModel {
  id: string;
  name: string;
  username: string;
  roles: string[];
  picture?: string;
}

@State<AuthenticationStateModel>({
  name: 'authState',
  defaults: {
    id: '',
    name: '',
    username: '',
    roles: [],
  },
})
@Injectable()
export class AuthState {
  constructor(private authenticationService: MsalService) {}

  @Selector()
  static getAuthData(state: AuthenticationStateModel): AuthenticationStateModel {
    return AuthState.getInstanceState(state);
  }

  private static setInstanceState(state: AuthenticationStateModel): AuthenticationStateModel {
    return { ...state };
  }

  private static getInstanceState(state: AuthenticationStateModel): AuthenticationStateModel {
    return { ...state };
  }

  @Action(SetAuthData)
  setAuthData({ setState }: StateContext<AuthenticationStateModel>, { payload }: SetAuthData) {
    setState(AuthState.setInstanceState(payload));
  }

  @Action(Logout)
  logout({ setState }: StateContext<AuthenticationStateModel>) {
    setState({
      id: '',
      name: '',
      username: '',
      roles: [],
    });

    this.authenticationService.logoutRedirect();
  }
}
